import { IconCode, IconGlobe, IconPlane } from '@shared/ui/v2';
import type { KeyboardEvent } from 'react';

export type Kind = 'telegram' | 'max' | 'widget' | 'api';

/** Значок канала: Telegram — самолётик, MAX — надпись, окно чата — глобус (без логотипов). */
export function ChBadge({ kind, size = 36 }: { kind: Kind; size?: number }) {
  return (
    <span className={`ch-badge is-${kind}`} style={{ width: size, height: size }}>
      {kind === 'telegram' && <IconPlane size={Math.round(size / 2.2)} />}
      {kind === 'max' && 'MAX'}
      {kind === 'widget' && <IconGlobe size={Math.round(size / 2.2)} />}
      {kind === 'api' && <IconCode size={Math.round(size / 2.2)} />}
    </span>
  );
}

export function StatusPill({ status }: { status: 'active' | 'paused' | 'disabled' }) {
  if (status === 'active') return <span className="ch-pill is-ok">Отвечает</span>;
  if (status === 'paused') return <span className="ch-pill is-pause">На паузе</span>;
  return <span className="ch-pill is-err">Не работает</span>;
}

/** «28 окт» / «28 октября 2026». */
export function dateRu(iso: string, long = false) {
  const d = new Date(iso);
  return long
    ? d
        .toLocaleDateString('ru-RU', {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          timeZone: 'Europe/Moscow',
        })
        .replace(' г.', '')
    : d
        .toLocaleDateString('ru-RU', { day: 'numeric', month: 'short', timeZone: 'Europe/Moscow' })
        .replace('.', '');
}

/** Стрелки в группе переключателей (role="radiogroup"): выбирают соседний вариант. */
export function radioKeys(e: KeyboardEvent<HTMLElement>) {
  const keys: Record<string, number> = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
  const step = keys[e.key];
  if (!step) return;
  const items = Array.from(
    e.currentTarget.querySelectorAll<HTMLElement>('[role="radio"]:not([disabled])'),
  );
  if (!items.length) return;
  const at = items.indexOf(document.activeElement as HTMLElement);
  const next = items[(Math.max(at, 0) + step + items.length) % items.length];
  e.preventDefault();
  next?.focus();
  next?.click();
}
